module.exports = __webpack_public_path__ + "static/media/tom.16e70e53.jpg";